import Vue from 'vue'

import cComponent from './cComponent'
import cPaginator from './cPaginator'
import cLoading from './cLoading'
import cWait from './cWait'

Vue.component('c-component', cComponent)
Vue.component('c-loading', cLoading)
Vue.component('c-paginator', cPaginator)
Vue.component('c-wait', cWait)
